export function formatarData(data) {

  

    var date = data.toString().split("T")[0];
    var dataEdit = date.split("-").reverse().join("/");
    return dataEdit;
  }